import { FC, ReactNode } from 'react'

import styled from 'styled-components'

import SettingsIcon from 'src/Assets/Svg/settings-outline.svg?react'
import TrackCoverIcon from 'src/Assets/Svg/pages-icons/TrackCover.svg'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import SpotifyIcon from 'src/Assets/Svg/platform-icons/Spotify.svg?react'
import TikTokIcon from 'src/Assets/Svg/platform-icons/TikTok.svg?react'
import ReelsIcon from 'src/Assets/Svg/platform-icons/Reels.svg?react'
import MetaAdsIcon from 'src/Assets/Svg/platform-icons/meta-ads.svg?react'

import { SimpleLabel } from '../SimpleLabel'
import { SmartImage } from '../SmartImage'
import { PrimaryLabel } from '../PrimaryLabel'
import { PreReleaseLabel } from '../PreReleaseLabel'

import { CampaignListItemProps } from '.'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  width: 100%;
`
const InfoBLock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`
const InfoBlockTrackInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`

const PlatformAndMewReleaseContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`

const ArtistName = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  word-break: break-word;
`
const TrackName = styled(ArtistName)`
  font-weight: 600;
  word-break: break-word;
`

const TrackImage = styled(SmartImage)`
  width: 68px;
  height: 68px;
  border-radius: 16px;
`

type CampaignTrackDetailsProps = Pick<
  CampaignListItemProps,
  | 'trackName'
  | 'artistName'
  | 'trackImage'
  | 'platform'
  | 'newRelease'
  | 'matchingType'
  | 'isPreRelease'
>

const platformIconMap: Partial<Record<CampaignPlatformTypeEnum, ReactNode>> = {
  [CampaignPlatformTypeEnum.SPOTIFY]: <SpotifyIcon />,
  [CampaignPlatformTypeEnum.TIKTOK]: <TikTokIcon />,
  [CampaignPlatformTypeEnum.REELS]: <ReelsIcon />,
  [CampaignPlatformTypeEnum.META]: <MetaAdsIcon width={16} height={16} />,
}
const platformTextMap: Partial<Record<CampaignPlatformTypeEnum, ReactNode>> = {
  [CampaignPlatformTypeEnum.SPOTIFY]: 'Spotify',
  [CampaignPlatformTypeEnum.TIKTOK]: 'TikTok',
  [CampaignPlatformTypeEnum.REELS]: 'Reels',
  [CampaignPlatformTypeEnum.META]: 'Meta Ads',
}

export const CampaignTrackDetails: FC<CampaignTrackDetailsProps> = ({
  platform,
  trackName,
  trackImage,
  artistName,
  newRelease,
  matchingType,
  isPreRelease,
}) => (
  <Container>
    <TrackImage
      width={68}
      height={68}
      src={trackImage}
      alt={trackName}
      fallbackSrc={TrackCoverIcon}
    />
    <InfoBLock>
      <InfoBlockTrackInfo>
        <TrackName>{trackName}</TrackName>
        <ArtistName>{artistName}</ArtistName>
      </InfoBlockTrackInfo>
      <PlatformAndMewReleaseContainer>
        <PrimaryLabel text={platformTextMap[platform]}>
          {platformIconMap[platform]}
        </PrimaryLabel>
        {isPreRelease && <PreReleaseLabel />}
        {newRelease && <SimpleLabel color='green'>New Release</SimpleLabel>}
        {matchingType === 'manual' && (
          <PrimaryLabel text='Manual'>
            <SettingsIcon />
          </PrimaryLabel>
        )}
      </PlatformAndMewReleaseContainer>
    </InfoBLock>
  </Container>
)
